import React from 'react';
import { CircularProgress } from '@material-ui/core';

import Logo from '../../../images/logo_only.png';

import './lazy.css';

export default class LazyBox extends React.Component {
    render() {
		const { children, height, loading = true } = this.props;
			return(
				<div className="lazy_content" >
					{loading === true && <div className="lazy_loading" style={{ minHeight: height}} >
						<div className="lazy__progress" >
							<div className="progress__loading" >
								<CircularProgress className="loading" thickness={1} size={45} />
							</div>
							<div className="progress__logo" >
								<img src={Logo} alt="" />
							</div>
						</div>
					</div>}
					{loading === false && children}
				</div>
			);
    }
}



// WEBPACK FOOTER //
// ./src/web/components/LazyBox/index.js